import React, { useState } from 'react';

const ProductsCard = () => {
  const [active, setActive] = useState('networkpro');
  const [isHovered, setIsHovered] = useState(false);

  const content = {
    networkpro: [
      // Network Switches
      {
        title: 'Network Switches',
        models: [
          {
            description: 'Cisco Catalyst 9000 Series',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Juniper EX Series',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'HP Aruba 5400R',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Dell EMC PowerSwitch',
            link: {
              url: '/Products',
            },
          },
        ],
      },
      // Network Routers
      {
        title: 'Network Routers',
        models: [
          {
            description: 'Cisco ISR 4000 Series',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Juniper MX Series',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'MikroTik CCR Series',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'TP-Link SafeStream',
            link: {
              url: '/Products',
            },
          },
        ],
      },
      // Network Firewalls
      {
        title: 'Network Firewalls',
        models: [
          {
            description: 'Huawei USG6000 Series',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Fortinet FortiGate',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Palo Alto PA Series',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Sophos XG Series',
            link: {
              url: '/Products',
            },
          },
        ],
      },
    ],
    cctvsurveillanve: [
      {
        title: 'Network Cameras',
        models: [
          {
            description: 'Hikvision: PTZ, Dome,  & Turret Cameras',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Dahua Technology: PTZ, Dome & Bullet Cameras',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Bosch: PTZ, Dome & Thermal Cameras',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Sony: PTZ, Dome & Box Cameras',
            link: {
              url: '/Products',
            },
          },
        ],
      },
      {
        title: 'Digital/Network Video Recorders',
        models: [
          {
            description: 'Hikvision Turbo HD DVR',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Dahua NVR 5000 Series',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Samsung Wisenet NVR',
            link: {
              url: '/Products',
            },
          },
        ],
      },
      {
        title: 'Surveillance Accessories',
        models: [
          {
            description: 'PoE Switches for CCTV',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'CCTV Cabling (RG59, CAT6)',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Camera Mounts and Housings',
            link: {
              url: '/Products',
            },
          },
        ],
      },
    ],
    datastorage: [
      {
        title: 'Enterprise Storage Systems',
        models: [
          {
            description: 'Dell EMC PowerStore',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'HPE 3PAR StoreServ',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'NetApp AFF Series',
            link: {
              url: '/Products',
            },
          },
        ],
      },
      {
        title: 'Backup and Disaster Recovery',
        models: [
          {
            description: 'Veeam Backup & Replication',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Acronis Cyber Backup',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Barracuda Backup',
            link: {
              url: '/Products',
            },
          },
        ],
      },
      {
        title: 'Cloud Storage Solutions',
        models: [
          {
            description: 'Amazon S3',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Microsoft Azure Blob Storage',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Google Cloud Storage',
            link: {
              url: '/Products',
            },
          },
        ],
      },
    ],
    accesscontrol: [
      {
        title: 'Uninterruptible Power Supply (UPS) Systems',
        models: [
          {
            description: 'Line-Interactive UPS',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Online Double-Conversion UPS',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Standby UPS',
            link: {
              url: '/Products',
            },
          },
        ],
      },
      {
        title: 'Battery Storage Systems',
        models: [
          {
            description: 'Lithium-Ion Batteries',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Lead-Acid Batteries',
            link: {
              url: '/Products',
            },
          },
          {
            description: 'Solar Batteries',
            link: {
              url: '/Products',
            },
          },
        ],
      },
    ],
  };

  const handleProductClick = (url) => {
    window.location.href = url; // Navigate to the product page
    window.close();             // Close the current window
  };

  return (
    <div className="relative group">
      <div 
        onMouseEnter={() => setIsHovered(true)} 
        onMouseLeave={() => setIsHovered(false)}
      >
        <button
          className={`relative px-2 py-2 text-gray-600 bg-white rounded ease-in-out transform focus:outline-none font-normal 
            after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-full after:h-[2px] after:transition-all after:duration-3000 
            ${isHovered ? 'hover:scale-110 after:bg-blue-500 after:w-full' : 'after:bg-transparent'}`}
        >
          Products
        </button>
        <div className="fixed left-1/2 transform -translate-x-1/2 mt-0.5 bg-white rounded-md hidden group-hover:block text-justify w-full sm:w-11/12 lg:max-w-1200px z-50 overflow-y-auto max-h-[80vh]">
          <div className="p-4 flex flex-col lg:flex-row text-justify h-auto lg:h-68vh">
            {/* Options on the left */}
            <div className="flex-shrink-0 mt-8 flex lg:flex-col overflow-x-auto lg:overflow-visible">
              <button
                className={`block px-4 py-2 text-gray-800 hover:bg-[#f2f3f4] font-normal ${active === 'networkpro' ? 'bg-[#f2f3f4]' : 'text-blue-900'}`}
                onClick={() => setActive('networkpro')}
              >
                Network Products
              </button>
              <button
                className={`block px-4 py-2 text-gray-800 hover:bg-[#f2f3f4] hover:text-blue-900 font-normal ${active === 'cctvsurveillanve' ? 'bg-[#f2f3f4]' : 'text-blue-900'}`}
                onClick={() => setActive('cctvsurveillanve')}
              >
                CCTV Surveillance 
              </button>
              <button
                className={`block px-4 py-2 text-gray-800 hover:bg-[#f2f3f4] hover:text-blue-900 font-normal ${active === 'datastorage' ? 'bg-[#f2f3f4]' : 'text-blue-900'}`}
                onClick={() => setActive('datastorage')}
              >
                Data Storage
              </button>
              <button
                className={`block px-4 py-2 text-gray-800 hover:bg-[#f2f3f4] hover:text-blue-900 font-normal ${active === 'accesscontrol' ? 'bg-[#f2f3f4]' : 'text-blue-900'}`}
                onClick={() => setActive('accesscontrol')}
              >
                Power Back-up
              </button>
            </div>
            {/* Vertical rule */}
            <div className="border-l border-gray-300 h-auto mx-4 hidden lg:block"></div>
            {/* Content on the right */}
            <div className="flex-grow p-4 overflow-x-auto lg:overflow-visible">
              <div className="flex flex-wrap lg:flex-nowrap lg:space-x-4">
                {content[active].map((item, index) => (
                  <div key={index} className="w-full sm:w-1/2 md:w-1/2 lg:w-1/3 bg-white rounded-lg overflow-hidden shadow-lg mb-4">
                    <div className="p-4">
                      <h3 className="text-lg text-gray-600 font-normal">{item.title}</h3>
                      <hr /> <br />
                      {item.models.map((model, idx) => (
                        <div key={idx} className="mb-2">
                          <p
                            onClick={() => handleProductClick(model.link.url)}
                            className="text-gray-500 hover:text-blue-900 text-sm font-normal cursor-pointer"
                          >
                            {model.description}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsCard;
